export default __webpack_public_path__ + "static/media/arrowTick.900aea3e.svg";